import { useEffect, useState } from 'react'
import AccountData from './AccountData/AccountData'
import { Box, Button, Drawer, Paper, styled } from '@mui/material';
import { anchorPositions } from '../Help/HelpPanel';
import Split from "react-split";
import HandymanIcon from '@mui/icons-material/Handyman';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import DataDepot from './DataDepot/DataDepot';
import CopyTo from './CopyTo/CopyTo';
import PDCConnection from './PDCConnection';
import TradingPartner from './TradingPartner/TradingPartner';
import TrackingReports from './TrackingReports/TrackingReports';
import AcceleratorWizard from './AcceleratorWizard/AcceleratorWizard';

export const StyledDrawer = styled(Drawer)(({ theme }) => ({
    '& .MuiDrawer-paper': {
        width: '100%',
        backgroundColor: 'transparent',
        boxShadow: 'none'
    },
}));


const Repository = ({ option, setOption, handleClose, setSnackbar, dir, pdcName, screen, origin, onPdcSelect }) => {
    const {t} = useTranslation();
    const [prevOption, setPrevOption] = useState(0);
    const [isAcceleratorInstalling, setIsAcceleratorInstalling] = useState(false);

    const handlePdcSelection = (selectedPdcData) => {
        if (onPdcSelect) {
            onPdcSelect(selectedPdcData);
        }
    };
    
    const handleCloseWrapper = () => {
        // Prevent closing if accelerator is installing
        if (isAcceleratorInstalling) {
            return;
        }
        handleClose();
    };
    
    //set prev option that CopyTo component can come back to when Done btn is clicked
    useEffect(() => {
        if (option !== 6) setPrevOption(option);
    }, [option]);

    return (
        <StyledDrawer
            anchor={anchorPositions.left}
            open={option !== null}
            onClose={handleCloseWrapper}
        >
            <Split
                className="split height-100 flex"
                direction="horizontal"
                gutterSize={4}
                snapOffset={0}
                dragInterval={4}
                minSize={[850, 0]}
                sizes={[67, 33]}
            >
                <div>
                    <Paper square sx={{ height: '100%', width: '100%', backgroundColor: 'white'}} >
                        <Box className="flex" sx={{ justifyContent: 'space-between', alignItems: 'center',padding:'.5rem 0 .5rem 1rem',borderBottom: '1px solid rgb(224, 224, 224)' }}>
                            <Box sx={{ fontSize: '18px', fontWeight: '500' }}>
                                {}
                                {option === 1 && t('DIAG_TRADING_PARTNER_TIT')}
                                {option === 2 && t('DATA_DEPOT')}
                                {option === 3 && t('LBL_TRACKING_REPORTS')}
                                {option === 4 && t('ACCOUNT_DATA_RIGHTS')}
                                {option === 5 && t('BTN_PREDEF_CONN')}
                                {option === 6 && t('Copy Repository Items')}
                                {option === 7 && 'Accelerator Wizard'}
                            </Box>
                            <Button onClick={handleCloseWrapper} size='small' disabled={isAcceleratorInstalling}><CloseIcon fontSize='large' /></Button>
                        </Box>
                        <Box sx={[2, 3, 7].includes(option) ? {height: "calc(100% - 60px)"} : {}}>
                            {option === 1 && <TradingPartner setOption={setOption} handleClose={handleClose} />}
                            {option === 2 && <DataDepot setOption={setOption} handleClose={handleClose}/>}
                            {option === 3 && <TrackingReports setSnackbar={setSnackbar} open={option === 3} setOption={setOption} handleClose={handleClose} showCancelButton />}
                            {option === 4 && <AccountData setSnackbar={setSnackbar} tabOpen={option === 4} handleClose={handleClose} setOption={setOption} />}
                            {option === 5 && <PDCConnection handleClose={handleClose} dir={dir} pdcName={pdcName} screen={screen} origin={origin} onPdcSelect={handlePdcSelection} />}
                            {option === 6 && <CopyTo prevOption={prevOption} setOption={setOption}/>}
                            {option === 7 && <AcceleratorWizard handleClose={handleClose} setIsInstalling={setIsAcceleratorInstalling} setSnackbar={setSnackbar} />}
                        </Box>
                    </Paper>
                </div>
                <Box></Box>
            </Split>
        </StyledDrawer>
    )
}

export default Repository
